<template>
  <div style="width: 100%;">
    <div style="padding-left: 20px">
      <h6 style="margin: 0px; color: #000; font-size: 30px; padding: 0px 0px 8px">
        {{ selectedQuiz.data }}
      </h6>

      <p style="font-size: 1rem; font-weight: 600">
        Correct: <span class="correct">{{ correctAnswerPercentage }}%</span> | Incorrect:
        <span class="incorrect">{{ 100 - correctAnswerPercentage - noAnswerPercentage }}%</span> | No Answer:
        <span class="no-answer">{{ noAnswerPercentage }}%</span>
      </p>
    </div>
    <div class="mcq-stats">
      <div class="mcq-text">
        <table class="scroll">
          <thead style="position: relative; padding: 0 1.2rem; margin-left: 1.5rem; font-size: small">
            <tr>
              <th style="font-size: 0.9rem; padding-left: 0.8rem">Answer</th>
              <th style="font-size: 0.9rem; text-align: end">% Chosen</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="option in enhancedOptions" :key="option.id" style="position: relative; padding: 0.3rem; margin-left: 1.5rem">
              <td>
                <span v-if="isShowSolution && option.on && option.label" style="color: green">&#x2713;</span>
                <span v-else-if="isShowSolution && option.label" style="color: red">&#x2717;</span>
                {{ option?.label }}
                {{ option.val }}
              </td>
              <td style="text-align: end">{{ option.percentage }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="padding: 0 20px; width: 50%;  position: relative;">
        <MCQPieCharts :option="enhancedOptions" :question="selectedQuiz.data" />
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref, watch} from 'vue'
import MCQPieCharts from './MCQPieCharts.vue'
import store from '@/store'

const props = defineProps({
  selectedQuiz: {
    type: Object,
  },
  isShowSolution: {
    type: Boolean,
  },
  maxStudentCount: {
    type: Number,
  },
})

const currentAnswers = computed(() => store.getters['student/currentVideoQuizAnswerList'])

const studentTotalCount = computed(() => props.maxStudentCount)

let maxStud = 0

const noAnswerPercentage = computed(() => {
  maxStud = Math.max(studentTotalCount.value, maxStud)
  const uniqueUids = new Set(currentAnswers.value.map((item) => item.uid))
  const cur = currentAnswers.value.filter((answer) => props.selectedQuiz?._id === answer.quizId).map((answer) => answer.answer)
  const emptyCount = cur.filter((item) => item.length === 0).length
  if (maxStud === 0) return 100
  const noAnswers = maxStud - uniqueUids.size
  if (noAnswers < 0) return 0
  return (((noAnswers + emptyCount) / maxStud) * 100).toFixed(0)
})

const enhancedOptions = computed(() => {
  const labels = ['A.', 'B.', 'C.', 'D.', 'E.', 'F.', 'G.', 'H.']
  const totalStudents = maxStud || 1

  const optionsWithLabels = props.selectedQuiz?.options.map((option, index) => {
    const optionCount = currentAnswers.value.filter((answer) => props.selectedQuiz?._id === answer.quizId && answer.answer.includes(option._id)).length
    return {
      ...option,
      label: labels[index] || '',
      percentage: ((optionCount / totalStudents) * 100).toFixed(0),
    }
  })

  optionsWithLabels.push({
    id: 'no-answer',
    val: 'No Answer',
    label: '',
    percentage: noAnswerPercentage.value,
  })

  watch(currentAnswers, (newAnswers) => {})

  return optionsWithLabels
})

const correctAnswerPercentage = computed(() => {
  maxStud = Math.max(studentTotalCount.value, maxStud)
  if (maxStud === 0) return 0
  const cur = currentAnswers.value.filter((answer) => props.selectedQuiz?._id === answer.quizId).map((answer) => answer.answer)
  const emptyCount = cur.filter((item) => item.length === 0).length
  const selectedOnIds = props.selectedQuiz?.options.filter((option) => option.on === true || option.selected === true).map((option) => option._id)
  const countMatches = cur.filter((arr) => arr.every((id) => selectedOnIds.includes(id)) && arr.length === selectedOnIds.length).length
  const finalCount = Math.max(0, countMatches - emptyCount)
  return ((finalCount / maxStud) * 100).toFixed(0)
})
</script>

<style scoped>
.mcq-stats {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.mcq-text {
  padding: 0.5rem 20px;
  width: 50%;
}

.correct {
  color: teal;
  font-size: 1rem;
}

.incorrect {
  color: red;
  font-size: 1rem;
}

.no-answer {
  font-size: 1rem;
}

table {
  border-collapse: collapse;
}

th {
  color: gray;
}

th:first-child {
  padding: 2rem 0;
  width: 150px;
}

tbody td {
  padding: 12px;
}

tbody tr:nth-child(odd) {
  background-color: #f9f9f9;
  padding: 1rem;
}

tbody tr:nth-child(even) {
  background-color: #eaeaea;
}

table.scroll tbody,
table.scroll thead tr {
  display: block;
}

table.scroll tbody {
  height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}

table.scroll tbody td,
table.scroll thead th {
  width: 140px;
}

table.scroll thead th:last-child {
  width: 156px;
}
</style>
